// token key
export const TOKEN_KEY = 'TOKEN__';

export const REFRESH_TOKEN_KEY = 'REFRESH__TOKEN__';

export const LOCALE_KEY = 'LOCALE__';

// user info key
export const USER_INFO_KEY = 'USER__INFO__';

// role info key
export const ROLES_KEY = 'ROLES__KEY__';

// menu info key
export const MENUS_KEY = 'MENUS_KEY__';

// project config key
export const PROJ_CFG_KEY = 'PROJ__CFG__KEY__';

export const MULTIPLE_TABS_KEY = 'MULTIPLE_TABS__KEY__';

export const APP_DARK_MODE_KEY_ = '__APP__DARK__MODE__';

// base global local key
export const APP_LOCAL_CACHE_KEY = 'COMMON__LOCAL__KEY__';

// base global session key
export const APP_SESSION_CACHE_KEY = 'COMMON__SESSION__KEY__';

export enum CacheTypeEnum {
  SESSION,
  LOCAL,
}

// 不在阅读协议
export const REMIND_KEY = 'not_remind_me';

// onboard
export const ONBOARD_PREFIX_KEY = 'on_board';

// 购买记录
export const BUY_RECORD_KEY = 'buy_record';

// ETP购买记录
export const ETP_BUY_RECORD_KEY = 'etp_buy_record';

// 转让记录
export const TRANSFER_RECORD_KEY = 'transfer_record';

// 今日不再提示
export const TODAY_NOT_REMIND = 'today_not_remind';

// 广播token的key

export const BROADCAST_TOKEN_KEY = 'refresh-token-channel';
// 广播刷新页面
export const BROADCAST_REFRESH_PAGE_KEY = 'refresh-page-channel';

// dmp DRO详情
export const DMP_DRO_INFO_KEY = 'dmp-dro-info';

// 市场查看模式如新手模式
export const MARKET_VIEW_MODAL = 'market-view-modal';

// 市场首页-已显示公告
export const MARKET_HOME_NOTICE = 'market-home-notice';

// 试算查询数据
export const MARKET_TRAIL_KEY = 'market-trail-key';
